import { render, staticRenderFns } from "./Phone.vue?vue&type=template&id=43479c49&"
import script from "./Phone.vue?vue&type=script&lang=js&"
export * from "./Phone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\RobertWiberg\\source\\repos\\server-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43479c49')) {
      api.createRecord('43479c49', component.options)
    } else {
      api.reload('43479c49', component.options)
    }
    module.hot.accept("./Phone.vue?vue&type=template&id=43479c49&", function () {
      api.rerender('43479c49', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Input/Phone.vue"
export default component.exports